module.exports = __webpack_public_path__ + "media/images/map/1-92d65f4abbfe63f8137b16bae5d0256b.png";